import {Component} from 'react'
import {Redirect} from 'react-router-dom'

import LoadingProfile from './Components/Profil/Loading/LoadingProfile.jsx'

import api from '../../../api.js'
import {generate} from '../../routes.js'

export default class RedirectProfileFreelanceContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirectRoute: null
    }
    this.cancelablePromise = null
  }

  makeCancelable = (promise) => {
    let hasCanceled_ = false

    const wrappedPromise = new Promise((resolve, reject) => {
      promise.then((val) =>
        hasCanceled_ ? reject({isCanceled: true}) : resolve(val)
      )
      promise.catch((error) =>
        hasCanceled_ ? reject({isCanceled: true}) : reject(error)
      )
    })

    return {
      promise: wrappedPromise,
      cancel() {
        hasCanceled_ = true
      },
    }
  }

  componentDidMount() {
    this.cancelablePromise = this.makeCancelable(
      api.freelances.getOne({freelance: this.props.match.params.freelance_id})
    )

    this.cancelablePromise
      .promise
      .then((response) => {
        this.setState({
          redirectRoute: generate({
            name: 'freelance-profile',
            parameters: {
              slug: response.data.slug
            }
          })
        })
      })
      .catch((e) => {
        console.warn(e)
        this.setState({
          redirectRoute: generate({
            name: 'homepage'
          })
        })
      })
  }

  componentWillUnmount() {
    if (this.cancelablePromise) {
      this.cancelablePromise.cancel()
    }
  }

  render() {
    if (this.state.redirectRoute) {
      return <Redirect to={this.state.redirectRoute} />
    } else {
      return (
        <LoadingProfile />
      )
    }
  }
}
